<template>
    <div class="container-fluid">
        <div class="page-title">
            <h4>Modifier un groupe d'utilisateurs</h4>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-block">
                        <div class="col-md-10 ml-auto mr-auto" v-show="stateForm != 1">
                            <form action="">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>Sélectionnez le groupe à modifier : </label>
                                            <select class="form-control" v-model="group_selected" required>
                                                <option v-bind:value="null" selected>Choisissez un groupe</option>
                                                <option v-for="group in user_groups" v-bind:value="group" v-bind:key="group.id">
                                                    {{group.name}}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="text-right mrg-top-5">
                                    <button type="button" class="btn btn-primary" v-bind:disabled="group_selected == null" v-on:click="next">Suivant</button>
                                </div>
                            </form>
                        </div>
                        <div class="col-md-10 ml-auto mr-auto" v-show="stateForm == 1">
                            <form @submit.prevent="add">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>Nom du groupe</label>
                                            <input v-model="name" type="text" 
                                                placeholder="Entrer le nom du groupe d'utilisateur" 
                                                class="form-control"
                                                @keypress="check_input($event)"
                                                
                                                minlength="1" 
                                                maxlength="45"
                                                required>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>Commentaire</label>
                                            <input v-model="comment" type="text" placeholder="Si besoin ajoutez un commentaire" class="form-control">
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>Sélectionnez le responsable pour ce groupe d'utilisateurs</label>
                                            <select id="responsableSelection" class="form-control" v-model="responsible" required>
                                                <option disabled value="null">Choisissez un responsable</option>
                                                <option v-for="adherent in adherents" v-bind:value="adherent.id" v-bind:key="adherent.id">
                                                    <div v-if="group_has_user">
                                                        <div v-for="group_user in group_selected.users">
                                                            <div v-if="adherent.id == group_user.id"> &#9733;</div>
                                                        </div>
                                                        {{adherent.title}} {{adherent.firstname}} {{adherent.lastname}}
                                                    </div>
                                                    <div v-else>
                                                        {{adherent.title}} {{adherent.firstname}} {{adherent.lastname}}
                                                    </div>
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="text-right mrg-top-5">
                                    <button class="btn btn-default" v-on:click="previous">Annuler</button>
                                    <button type="submit" class="btn btn-primary">Modifier</button>
                                </div>
                                <div class="alert alert-danger" role="alert" v-if="error">
                                            Impossible d'éditer le groupe ! Veuillez contacter KEMTAG
                                     <i class="ti-close float-right mt-1" @click="error = false"></i>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import api from "../../config/_api";
    import { mapGetters } from 'vuex';
    //import { mapMutations } from 'vuex';
    //import adherents from "../../store/modules/adherents";

    export default {
        name: "Edit",
        data () {
            return {
                group_selected: null,
                name: "",
                comment: "",
                responsible: null,
                group_has_user: false,
                stateForm: 0,
                error: false,
            }
        },
        computed: {
            ...mapGetters({
                user_groups: 'user_groups/user_groups',
                adherents: 'adherents/adherents',
            }),
        },
        mounted() {
            this.$store.dispatch('user_groups/getGroups');
            this.$store.dispatch('adherents/getUtilisateurs');
        },
        methods: {
            previous() {
                this.group_selected = null;
                this.stateForm = 0;
            },
            next() {
                this.name = this.group_selected.name;
                this.comment = this.group_selected.comment;
                this.responsible = this.group_selected.responsible_id == 1 ? null : this.group_selected.responsible_id;
                if(this.group_selected.users.length>0){
                    this.group_has_user = true;
                }
                else{
                    this.group_has_user = false;
                }
                this.stateForm = 1;
            },
            add() {
                let data = {
                    name: this.name,
                    responsible_id: this.responsible,
                    comment: this.comment
                };

                this.axios({url: api.url + 'user_groups/' + this.group_selected.id + '?structure_id=' + this.$store.getters.structure_id, data: data, method: 'PUT' })
                        .then(resp => {
                            if(resp.status < 400){
                                this.$router.push("/usergroup/index");
                            }
                    })
                    .catch(err => {
                        this.error = true;
                        console.log(err);
                    });

            },
            check_input: function(event){
                if( event.keyCode < 8 ||  event.keyCode > 122 || event.keyCode==13 || event.keyCode==33 || event.keyCode==34 || event.keyCode==35 || event.keyCode==36 || event.keyCode==37 || event.keyCode==38 || event.keyCode==39 || event.keyCode==40 || event.keyCode==41 || event.keyCode==42 || event.keyCode==43 || event.keyCode==44 || event.keyCode==46 || event.keyCode==47 || event.keyCode==58 || event.keyCode==59 || event.keyCode==60 || event.keyCode==61 || event.keyCode==62 || event.keyCode==63 || event.keyCode==64 || event.keyCode==91 || event.keyCode==92 || event.keyCode==93 || event.keyCode==94 || event.keyCode==96) event.returnValue = false;
                if( event.which < 8 ||  event.which > 122  || event.which==13 || event.which==33 || event.which==34 || event.which==35 || event.which==36 || event.which==37 || event.which==38 || event.which==39 || event.which==40 || event.which==41 || event.which==42 || event.which==43 || event.which==44|| event.which==46 ||  event.which==47 ||  event.which==58 ||  event.which==59 ||  event.which==60 ||  event.which==61 ||  event.which==62 ||  event.which==63 ||  event.which==64 ||  event.which==91 ||  event.which==92 ||  event.which==93 ||  event.which==94 ||  event.which==96) return false;
            }
        }
    }
</script>

<style scoped>

</style>